/**
 * ProcessedDataSection Component
 * Displays processed data table after adjustments
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import AnalysisTable from '../../../shared/components/tables/AnalysisTable';
import type { InfoType } from '../types/dataAdjustments.types';

interface ProcessedDataSectionProps {
  adjustedData: InfoType[];
  processedDataFrames: Array<unknown>;
}

const ProcessedDataSection: React.FC<ProcessedDataSectionProps> = ({
  adjustedData,
  processedDataFrames
}) => {
  const { t } = useTranslation('dataAdjustments');
  
  // Transform data to AnalysisTable format
  const transformToAnalysisFormat = (data: InfoType) => {
    return {
      fileName: data["Name der Datei"],
      mesurmentName: data["Name der Messreihe"],
      startTime: data["Startzeit (UTC)"],
      endTime: data["Endzeit (UTC)"],
      timeStepSize: data["Zeitschrittweite [min]"],
      offset: data["Offset [min]"],
      dataPoints: data["Anzahl der Datenpunkte"],
      numericDataPoints: data["Anzahl der numerischen Datenpunkte"],
      numericPercentage: Number(data["Anteil an numerischen Datenpunkten"]),
    };
  };

  const processedTableData = adjustedData.map(transformToAnalysisFormat);
  
  if (processedTableData.length === 0 || processedDataFrames.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-6">
      <h2 className="text-xl font-bold mb-4">
        {t('processedData.title')}
      </h2>
      <AnalysisTable analyses={processedTableData} />
    </div>
  );
};

export default ProcessedDataSection;
